import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
// import React
import dayjs from "dayjs";

// @mui material components
import Card from "@mui/material/Card";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { TextField } from "@mui/material";
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
import PdfViewer from "examples/PdfViewer";
// import ReportsService from "services/reports-service";
import PendingAmountService from "services/reports-pending-amount";
import PaymentsService from "services/payments-service";

// Helpers
import Helpers from 'utils/helpers';

const PaymentDetails = () => {
    const { id: paramPaymentId } = useParams();
    const navigate = useNavigate();

    const [payment_id, setPaymentId] = useState(paramPaymentId);
    const [dataResponse, setDataResponse] = useState(null);
    const [paymentDetails, setPaymentDetails] = useState(null);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    const [isShowPdf, setIsShowPdf] = useState(false);

    useEffect(() => {
        const autoDownload = async () => {
            try {
                await handleDownloadClick();
            } catch (error) {
                console.error('Error during automatic download:', error);
                navigate("/payments");
            }
        };

        autoDownload();
    }, []);

    const fetchPdfFile = async (payload) => {
        try {
            const response = await PaymentsService.getReceiptPDF(payload);
            setDataResponse(response);
        } catch (error) {
            console.error('Error fetching PDF:', error);
            // Return to the payments page if there's an error
            navigate("/payments");
        }
    };

    const fetchDetails = async (payment_id) => {
        try {
            const response = await PaymentsService.getReceiptDetails(payment_id);
            setPaymentDetails(response);
        } catch (error) {
            console.error(error);
            // Return to the payments page if there's an error
            navigate("/payments");
        }
    };

    const handleBackClick = () => {
        navigate("/payments");
    };

    const handleDownloadClick = async () => {
        const payload = {
            id: payment_id,
            pdf: true
        };
        fetchDetails(payment_id);
        await fetchPdfFile(payload);
        setIsShowPdf(true);
        setPdfFile(null);
    };

    return (
        <DashboardLayout>
            <MDBox mb={2} display="flex" alignItems="center" gap={2}>
                <MDButton
                    variant="gradient"
                    sx={{
                        padding: "12px 30px",
                        backgroundColor: "#388e3c",
                        color: "#ffffff",
                        borderRadius: "0.2rem",
                        "&:hover": {
                            backgroundColor: "#919191",
                            color: "#fff",
                        },
                        "&:disabled": {
                            background: "#e0e0e0"
                        }
                    }}
                    onClick={handleBackClick}
                >
                    Back to Payments
                </MDButton>
            </MDBox>
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12} md={6}>
                        {paymentDetails && (
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="success"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                <MDTypography variant="h6" color="white">
                                    Summary - {paymentDetails.receipt_number}
                                </MDTypography>
                                </MDBox>
                                <MDBox p={3}>
                                    <MDTypography variant="body2">
                                        <strong>Being Payment For:</strong> {paymentDetails.being_payment_for}
                                    </MDTypography>
                                    <MDTypography variant="body2">
                                        <strong>Amount:</strong> {paymentDetails.amount}
                                    </MDTypography>
                                    <MDTypography variant="body2">
                                        <strong>Payment Date:</strong> {paymentDetails.payment_date}
                                    </MDTypography>
                                    <MDTypography variant="body2">
                                        <strong>Payment Method:</strong> {paymentDetails.payment_method?.display_name}
                                    </MDTypography>
                                    <MDTypography variant="body2">
                                        <strong>Property:</strong> {paymentDetails.property?.property_name}
                                    </MDTypography>
                                    <MDTypography variant="body2">
                                        <strong>Tenant Code:</strong> {paymentDetails.lease?.lease_code}
                                    </MDTypography>
                                    <MDTypography variant="body2">
                                        <strong>Tenant Name:</strong> {paymentDetails.tenant?.first_name}
                                    </MDTypography>
                                    <MDTypography variant="body2">
                                        <strong>Unit:</strong> {paymentDetails.lease?.unit_names}
                                    </MDTypography>
                                    <MDTypography variant="body2">
                                        <strong>Lease Address:</strong> {paymentDetails.lease?.agreement_doc}
                                    </MDTypography>
                                    {/* Add more fields as needed */}
                                </MDBox>
                            </Card>
                        )}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <PdfViewer
                            dataResponse={dataResponse}
                            options={{ theme: 'dark', defaultScale: 1.5 }}
                            isShowPdf={isShowPdf}
                            pdfFile={pdfFile}
                            setPdfFile={setPdfFile}
                            setButtonDisabled={setButtonDisabled}
                        />
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
};

export default PaymentDetails;
